import type { RuntimeConfig } from "nuxt/schema";

export const useGetBaseUrl = (_router: URL, runtimeConfig: RuntimeConfig) => {
  return runtimeConfig.public.baseUrl as string;
};
